﻿import { Component, EventEmitter, OnInit, Output } from "@angular/core";

/* Import model */
import { AddressCodeData} from "../../../model/jubili/address-information/address-code";
import { AddressFilterData, AddressInformationData } from "../../../model/jubili/address-information/address-information";
import { AddressInformationService } from "../../../service/api/jubili/address-information.service";

@Component({
    selector: "bo-jub-address-information",
    templateUrl: "./address-information.component.html",
    styleUrls: ["./address-information.component.scss"]

})

export class AddressInformationComponent implements OnInit {

    constructor(
        private addressInformationService: AddressInformationService
    ) { }

    addressCountryInformationData: Array<AddressInformationData> = [];
    addressProvinceInformationData: Array<AddressInformationData> = [];
    addressDistrictInformationData: Array<AddressInformationData> = [];

    addressCodeData: AddressCodeData = new AddressCodeData();
    addressdata: AddressFilterData = new AddressFilterData();
    disabledProvince: boolean = true;
    disabledDistrict: boolean = true;
    // using filter
    country: number = 0;
    province: number = 0;
    district: number = 0;
    languageCode: string = "";

    @Output("filteraddress") filteraddress = new EventEmitter<AddressFilterData>();

    ngOnInit(): void {
        this.languageCode = "en";
        this.initialAddressInformation();
    }

    public initialAddressInformation(): void {
        // get data country
        this.addressInformationService.getCountry(this.languageCode)
        .subscribe(
            Response => {
                this.addressCountryInformationData = Response;
            }
        );
    }

    filterCountry(value: any): void {
        this.disabledProvince = false;
        this.addressdata.province = ""; // clear province
        this.addressdata.district = ""; // clear district
        this.province = 0;
        this.district = 0;
        this.addressdata.country = value.id;
        if (value === 0) { // เช็คว่าถ้าผู้ใช้เลือก country:all
            this.disabledProvince = true;
            this.disabledDistrict = true;
            this.addressdata.country = "";
            this.addressProvinceInformationData = [];
            this.addressDistrictInformationData = [];
        } else {
            this.addressInformationService.getProvince(value.id, this.languageCode)
            .subscribe(
                Response => {
                    this.addressProvinceInformationData = Response;
                }
            );
        }
        this.sendTofilter();
    }

    filterProvince(value: any): void {
        this.disabledDistrict = false;
        this.addressdata.district = ""; // clear district
        this.district = 0;
        this.addressdata.province = value.id;
        if (value === 0) { // เช็คว่าถ้าผู้ใช้เลือก province:all
            this.disabledDistrict = true;
            this.addressdata.province = "";
            this.addressDistrictInformationData = [];
        } else {
            this.addressInformationService.getDistrict(value.id, this.languageCode)
            .subscribe(
                Response => {
                    this.addressDistrictInformationData = Response;
                    console.log(this.addressDistrictInformationData);
                }
            );
        }
        this.sendTofilter();
    }

    filterDistrict(value: any): void {
        this.addressdata.district = value.id;
        if (value === 0) { // เช็คว่าถ้าผู้ใช้เลือก district:all
            this.addressdata.district = "";
        }
        this.sendTofilter();
    }

    // send address
    sendTofilter(): void {
        this.filteraddress.emit(this.addressdata);
    }
}
